import React, { useState, useEffect } from "react";
import "./ViewWaterInvoices.scss"; // Import CSS
import "../../../assets/reusableComponents/InvoiceEditHighlight.scss";

//import components
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";
import customToasts from "../../../assets/reusableComponents/myToasts";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

//redux imports
import { useSelector, useDispatch } from "react-redux";

import { listWaterInvoices } from "../../../../redux/slices/sliceActions";

const ViewInvoicesTable = () => {
  const sampleInvoices = [
    {
      id: "1",
      type: "rent",
      date: "2023-01-01",
      dueDate: "2023-01-15",
      amount: 1200,
      status: "paid",
      reference: "INV-2023-001",
    },
    {
      id: "2",
      type: "water",
      date: "2023-01-05",
      dueDate: "2023-01-20",
      amount: 85,
      status: "paid",
      reference: "INV-2023-002",
    },
    {
      id: "3",
      type: "rent",
      date: "2023-02-01",
      dueDate: "2023-02-15",
      amount: 1200,
      status: "paid",
      reference: "INV-2023-003",
    },
    {
      id: "4",
      type: "water",
      date: "2023-02-05",
      dueDate: "2023-02-20",
      amount: 92,
      status: "paid",
      reference: "INV-2023-004",
    },
    {
      id: "5",
      type: "rent",
      date: "2023-03-01",
      dueDate: "2023-03-15",
      amount: 1200,
      status: "paid",
      reference: "INV-2023-005",
    },
    {
      id: "6",
      type: "water",
      date: "2023-03-05",
      dueDate: "2023-03-20",
      amount: 78,
      status: "paid",
      reference: "INV-2023-006",
    },
    {
      id: "7",
      type: "rent",
      date: "2023-04-01",
      dueDate: "2023-04-15",
      amount: 1200,
      status: "pending",
      reference: "INV-2023-007",
    },
    {
      id: "8",
      type: "water",
      date: "2023-04-05",
      dueDate: "2023-04-20",
      amount: 81,
      status: "pending",
      reference: "INV-2023-008",
    },
    {
      id: "9",
      type: "rent",
      date: "2023-05-01",
      dueDate: "2023-05-15",
      amount: 1200,
      status: "overdue",
      reference: "INV-2023-009",
    },
    {
      id: "10",
      type: "water",
      date: "2023-05-05",
      dueDate: "2023-05-20",
      amount: 89,
      status: "overdue",
      reference: "INV-2023-010",
    },
  ];

  const dispatch = useDispatch();
  const { waterinvoices, properties } = useSelector(
    (state) => state.landlordslice
  );

  const [invoicesToDisplay, setInvoicesToDisplay] = useState([]);
  useEffect(() => {
    console.log("waterinvoices", waterinvoices);
    if (waterinvoices?.waterInvoices) {
      const formatedInvoices = waterinvoices?.waterInvoices?.map((invoice) => {
        const formatDate = (dateString) => {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        return {
          id: invoice._id,
          house_no: invoice?.house?.house_no,
          unit_cost: invoice.property.water_charge,
          property: invoice.property.name,
          previous_reading: invoice?.meter_reading?.previous_reading,
          current_reading: invoice?.meter_reading?.current_reading,
          amount: invoice.water ??
            (invoice?.meter_reading?.current_reading - invoice?.meter_reading?.previous_reading) *
              invoice.property.water_charge,
          isWaterEdited: invoice.isEdited?.water === true,
          status: invoice.status,
        };
      });
      setInvoicesToDisplay(formatedInvoices);
    }
  }, [waterinvoices]);

  //Navigation variables
  const [hovered, setHovered] = useState(false);
  const [hoveredSecond, setHoveredSecond] = useState(false);

  // apartment  variables
  const [apartmentChoices, setApartmentChoices] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [selectedApartment, setSelectedApartment] = useState(
    properties[0]?.name
  );
  useEffect(() => {
    // alert("test")
    const selectedApartmentID = properties.find(
      (property) => property.name == selectedApartment
    )?._id;

    if (selectedApartmentID) {
      const monthNumber =
        selectedMonth === "Select Month"
          ? new Date().getMonth() + 1
          : monthChoices.indexOf(selectedMonth) + 1;
      const yearNumber =
        selectedYear === "Select Year"
          ? new Date().getFullYear()
          : parseInt(selectedYear);

      setIsFetching(true);
      dispatch(
        listWaterInvoices({
          property_id: selectedApartmentID,
          month: monthNumber,
          year: yearNumber,
        })
      )
        .unwrap()
        .then((res) => {
          //  console.log("water invoices gotten", res)
        })
        .finally(() => {
          setIsFetching(false);
        });
    }
  }, [selectedApartment]);

  useEffect(() => {
    if (Object.keys(properties).length > 0) {
      setApartmentChoices([...properties.map((property) => property.name)]);
    }
  }, [properties]);

  //date variables
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const daySuffix = (day) => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${daySuffix(day)} ${month} ${year}`;
  };
  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  //month variables
  const [selectedMonth, setSelectedMonth] = useState("Select Month");
  const monthChoices = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  //year variables
  const [selectedYear, setSelectedYear] = useState("Select Year");
  const currentYear = new Date().getFullYear();
  const yearChoices = Array.from({ length: 21 }, (_, i) => currentYear - i);

  //is filter button clicked
  const [isFilterButtonClicked, setIsFilterButtonClicked] = useState(false);
  const applyFilters = () => {
    if (!waterinvoices?.waterInvoices) {
      console.log("here", waterinvoices);
      return;
    } else {
      setIsFilterButtonClicked(true);
      const selectedApartmentID = properties.find(
        (property) => property.name == selectedApartment
      )?._id;

      if (selectedApartmentID) {
        const monthNumber = monthChoices.indexOf(selectedMonth) + 1;
        setIsFetching(true);
        dispatch(
          listWaterInvoices({
            property_id: selectedApartmentID,
            month: monthNumber,
            year: selectedYear,
          })
        )
          .unwrap()
          .finally(() => {
            setIsFetching(false);
          });
      } else {
        setIsFetching(false);
      }

      // const formatedInvoices = filteredInvoices.map((invoice) => {
      //   const formatDate = (dateString) => {
      //     const date = new Date(dateString);
      //     const year = date.getFullYear();
      //     const month = String(date.getMonth() + 1).padStart(2, "0");
      //     const day = String(date.getDate()).padStart(2, "0");
      //     return `${year}-${month}-${day}`;
      //   };

      //   return {
      //     id: invoice._id,
      //     house_no: invoice?.house?.house_no,
      //     unit_cost: invoice.property.water_charge,
      //     previous_reading: invoice?.meter_reading?.previous_reading,
      //     current_reading: invoice?.meter_reading?.current_reading,
      //     property: invoice.property.name,
      //     type: "rent",
      //     date: formatDate(invoice.createdAt),
      //     dueDate: formatDate(invoice?.due_date),
      //     amount: invoice.total,
      //     status: invoice.status,
      //     reference: invoice._id,
      //   };
      // });

      // setInvoicesToDisplay(formatedInvoices);
    }
  };

  return (
    <div className="view-invoices">
      <div className="title-section">
        <div className="title-and-description">
          <div className="title">View water invoices</div>
          <div className="description">View water invoice history</div>
        </div>
      </div>
      <div className="horizontal-line"></div>
      <div className="filters-container">
        <div className="drop-down">
          <div className="box-title">Apartment Choice</div>
          <div className="select">
            <DropdownSelect
              choices={apartmentChoices}
              defaultChoice={selectedApartment}
              onSelect={setSelectedApartment}
            />
          </div>
        </div>
        <div className="box">
          <div className="box-title">Month</div>
          <div className="select">
            <DropdownSelect
              choices={monthChoices}
              defaultChoice={selectedMonth}
              onSelect={setSelectedMonth}
              backgroundColor={"transparent"}
              textColor={"#192a3a"}
              border={"1px solid #ccc"}
            />
          </div>
        </div>
        <div className="box">
          <div className="box-title">Year</div>
          <div className="select">
            <DropdownSelect
              choices={yearChoices}
              defaultChoice={selectedYear}
              onSelect={setSelectedYear}
              backgroundColor={"transparent"}
              textColor={"#192a3a"}
              border={"1px solid #ccc"}
            />
          </div>
        </div>
        <div className="apply-filters-button">
          <div className="box-title">Confirm </div>
          <button
            onClick={() => {
              if (
                selectedApartment === "Select Apartment" ||
                selectedMonth === "Select Month" ||
                selectedYear === "Select Year"
              ) {
                alert("Please fill in all the fields before applying filters.");
                return;
              }

              const selectedApartmentID = properties.find(
                (property) => property.name == selectedApartment
              )?._id;
              const monthNumber = monthChoices.indexOf(selectedMonth) + 1;

              dispatch(
                listWaterInvoices({
                  property_id: selectedApartmentID,
                  month: monthNumber,
                  year: selectedYear,
                })
              ).then((res) => {
                if (res?.payload?.data?.waterInvoices) {
                  applyFilters();
                }
              });
            }}
          >
            Apply Filters
          </button>
        </div>
      </div>
      <div className="horizontal-line"></div>

      <div className="table-container">
        <table className="invoices-table">
          <thead>
            <tr>
              <th className="title">House Number</th>
              <th className="title">Unit Cost</th>
              <th className="title">Previous Reading</th>
              <th className="title">Current Reading</th>
              <th className="title">Units</th>
              <th className="title">Amount</th>
            </tr>
          </thead>
          <tbody>
            {isFetching ? (
              <tr>
                <td colSpan="6">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px', gap: '10px' }}>
                    <div className="spinner" style={{ width: "40px", height: "40px", border: "4px solid #00B1A9", borderTop: "4px solid transparent", borderRadius: "50%", animation: "spin 1s linear infinite" }}></div>
                    Fetching water invoices...
                  </div>
                </td>
              </tr>
            ) : invoicesToDisplay.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                  No invoices to display
                </td>
              </tr>
            ) : (
              invoicesToDisplay.map((invoice) => (
                <tr
                  key={invoice.id}
                  className={invoice.isWaterEdited ? "invoice-row-edited" : undefined}
                  title={invoice.isWaterEdited ? "Water amount manually changed" : undefined}
                >
                  <td className="data">{invoice.house_no}</td>
                  <td className="data">{invoice.unit_cost}</td>
                  <td className="data">{invoice.previous_reading}</td>
                  <td className="data">{invoice.current_reading}</td>
                  <td className={invoice.status}>
                    <span className="data">
                      {invoice.current_reading - invoice.previous_reading}
                    </span>
                  </td>
                  <td className="data">
                    {invoice.amount}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
};

export default ViewInvoicesTable;
